import { useState } from "react";
import { Icon, GoldButton } from "./ui";

/* Premium multi-step shell: one section per screen, gold progress indicator. */
export function Wizard({ steps, step, setStep, canNext, onSubmit, busy, children, submitLabel = "Submit for Consideration", testId = "pd-wizard" }) {
  const last = step === steps.length - 1;
  return (
    <div className="max-w-3xl mx-auto" data-testid={testId}>
      <div className="flex items-center gap-2 mb-14" data-testid={`${testId}-progress`}>
        {steps.map((s, i) => (
          <div key={s} className="flex-1">
            <div className={`h-px transition-colors duration-500 ${i <= step ? "bg-[#C9A84C]" : "bg-[#C9A84C]/20"}`} />
            <div className={`mt-3 text-[9px] tracking-[0.22em] uppercase hidden md:block ${i === step ? "pd-gold" : "pd-muted"}`}>{i + 1}. {s}</div>
          </div>
        ))}
      </div>
      <div className="pd-label mb-3">Step {step + 1} of {steps.length}</div>
      <h2 className="pd-serif text-4xl md:text-5xl tracking-wide mb-12" data-testid={`${testId}-step-title`}>{steps[step]}</h2>
      <div key={step} className="pd-enter space-y-7">{children}</div>
      <div className="flex items-center justify-between gap-6 mt-16 pt-8 border-t pd-line">
        <button className="pd-nav-link disabled:opacity-30" disabled={step === 0 || busy} onClick={() => setStep(step - 1)} data-testid={`${testId}-back`}>← Back</button>
        {last ? <GoldButton solid disabled={!canNext || busy} onClick={onSubmit} testId={`${testId}-submit`}>{busy ? "Submitting…" : submitLabel} <Icon.Arrow size={14} /></GoldButton>
          : <GoldButton disabled={!canNext || busy} onClick={() => setStep(step + 1)} testId={`${testId}-next`}>Continue <Icon.Arrow size={14} /></GoldButton>}
      </div>
    </div>
  );
}

export const Field = ({ label, hint, children }) => <label className="block"><div className="pd-label mb-3">{label}</div>{children}{hint && <div className="pd-muted text-xs mt-2 leading-relaxed">{hint}</div>}</label>;
export const Choice = ({ options, value, onChange, testPrefix }) => (
  <div className="grid sm:grid-cols-2 gap-3">
    {options.map((o) => (
      <button key={o.value} type="button" onClick={() => onChange(o.value)} data-testid={`${testPrefix}-${o.value}`}
              className={`text-left border p-6 transition-all duration-300 ${value === o.value ? "border-[#C9A84C] bg-[#C9A84C]/5" : "pd-line hover:border-[#C9A84C]/50"}`}>
        <div className="flex items-center gap-3 pd-gold mb-2">{o.icon}<span className="pd-label !text-[#F5F5F0]">{o.label}</span></div>
        {o.caption && <div className="pd-muted text-sm leading-relaxed">{o.caption}</div>}
      </button>
    ))}
  </div>
);
export function useWords(text) { return (text || "").trim().split(/\s+/).filter(Boolean).length; }
export const useStepper = () => useState(0);
